import template from './reject_users.html';
import tr from '../../lib/default-translator.js';

class RejectUsersViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}

	async save_reject()
	{
		let data = {
			employee_id: this.dialog.bindings.data.employee_id,
			rejected_reason: $('#txtRejectionReason').val()
		};

		let res = await Grape.fetches.postJSON('/employee/reject_user_access', data);
		if (res.status == 'OK')
			Grape.alerts.alert({type: 'success', message: tr('Successfully rejected user.'), title: tr('Success', 'Success')});
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});

		this.dialog.close();
	};
};

class RejectUsersPage 
{
	constructor (bindings)
	{
		this.viewModel = new RejectUsersViewModel(this);
		this.bindings = bindings;
	};
};

export default {
	name: 'RejectUsers',
	dialog_class: RejectUsersPage,
	template: template,
	template_filename: 'translation/dialogs/reject_users',
	provider: 'ps'
};
